// eslint-disable-next-line import/no-cycle
import QueryWhereNode from './query-where-node';
// eslint-disable-next-line import/no-cycle
import QueryWhereChildren from './query-where-children';
import QueryWhereRules from './query-where-rules';
import QueryHaving from '~/scripts/services/model/query-having';

/**
 * @param {QueryWhereChild} c
 * @param {?QueryWhereChild} parent
 * @returns {QueryWhereChild}
 */
const childMap = (/** @type {any} */ c, parent) => {
	return new QueryWhereChild({
		children: c.children,
		having:   c.having,
		node:     c.node,
		rules:    c.rules,
	}, parent);
};

/**
 * @param {QueryWhereChildren} c
 * @param {?QueryWhereChild} parent
 * @returns {QueryWhereChildren}
 */
const childrenMap = (c, parent) => {
	return new QueryWhereChildren({
		condition: c.condition,
		items:     c.items.map((/** @type {any} */ c2) => c2 && childMap(c2, parent)),
	});
};

export default class QueryWhereChild {
	/** @type {?QueryWhereChild} */
	#parent;

	/**
	 * @param {any} child
	 * @param {?QueryWhereChild} parent
	 */
	constructor(child = null, parent = null) {
		this.#parent = parent;

		/** @type {?(QueryWhereNode | 'parent' | 'self')} */
		const node = child?.node ? (typeof child.node === 'string' ? child.node : new QueryWhereNode(child.node)) : null;

		/** @type {?QueryWhereChildren} */
		this.children = child?.children ? childrenMap(child.children, this.#parent) : null;

		/** @type {import('./query-having').default | undefined} */
		this.having = child?.having ? new QueryHaving(child.having) : undefined;

		/** @type {?(QueryWhereNode | 'parent' | 'self')} */
		this.node = node;

		/** @type {?QueryWhereRules} */
		this.rules = child?.rules ? new QueryWhereRules(child.rules, this.node) : null;
	}

	/**
	 * @param {QueryWhereNode} node
	 * @returns {undefined|QueryWhereChild}
	 */
	findChildByNode(node) {
		if (this.node instanceof QueryWhereNode && this.node.kid === node.kid && this.node.linker_kid === node.linker_kid) {
			return this;
		}
		else if (this.children?.items && this.children.items.length > 0) {
			for (const child of this.children.items) {
				const c = child.findChildByNode(node);
				if (c) {
					return c;
				}
			}
		}
		return undefined;
	}

	getParent() {
		return this.#parent;
	}

	removeRules() {
		this.rules = null;
	}

	/**
	 * @param {?QueryWhereChild} parent
	 */
	setParent(parent) {
		this.#parent = parent;
	}
}
